import { PropsWithChildren, ReactNode } from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives";
import { N0 } from "@atlaskit/theme/colors";

const rootCss = css({
    margin: "64px auto",
    backgroundColor: "#1868db",
    position: "relative",
    maxWidth: 1312
});

const angledEdgeCss = css({
    position: "absolute",
    zIndex: 1,
    maxWidth: 1312,
    width: "100%",
    insetBlockEnd: 0
});

const headingCss = css({
    color: N0,
    fontSize: 32,
    fontWeight: 700,
    lineHeight: "38px",
    textAlign: "center",
    margin: 0,
    padding: "60px 24px 0 24px",

    [media.above.sm]: {
        fontSize: 36,
        lineHeight: "42px",
        padding: "47px 24px 0 24px"
    },

    [media.above.lg]: {
        fontSize: 40,
        lineHeight: "48px",
        paddingBlockStart: 60
    }
});

const childrenCss = css({
    position: "relative",
    zIndex: 2,
    insetBlockStart: 48,
    insetInlineStart: 0,
    insetInlineEnd: 0,
    marginInlineStart: "auto",
    marginInlineEnd: "auto",
    paddingInlineStart: 32,
    paddingInlineEnd: 32,
    display: "flex",
    justifyContent: "center",
    alignItems: "stretch",
    flexDirection: "row",
    gap: 32,

    [media.below.md]: {
        flexDirection: "column",
        alignItems: "center",
        gap: 48
    }
});

export interface AddonsContainerProps extends PropsWithChildren {
    heading: ReactNode;
}

export const AddonsContainer = (props: AddonsContainerProps) => {
    return (
        <div css={rootCss}>
            <h1 css={headingCss}>{props.heading}</h1>
            <div css={angledEdgeCss}>
                <AngledEdgeBackground />
            </div>
            <div css={childrenCss}>{props.children}</div>
        </div>
    );
};

const AngledEdgeBackground = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1312 180"
            fill="none"
            width="100%"
            height="100%"
            css={css({
                position: "relative",
                insetBlockEnd: -8
            })}
        >
            <path
                d="M0 180L1312 180L1312 0.000114699L5.65586e-06 115.305L0 180Z"
                fill="white"
            />
        </svg>
    );
};
